import React from 'react';
import {
  CardStyleInterpolators,
  createStackNavigator,
} from '@react-navigation/stack';
import {makeId} from '../../utils';
import {E_NAVIGATION_DESTINATIONS} from '../../@types';
import {GateCardDetail, GateCards } from './screens';

const Stack = createStackNavigator();

const GatecardsNavigator = () => {
  const options = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  return (
    <Stack.Navigator>
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.GATE_CARDS_LIST}
        component={GateCards}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
 
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.GATE_CARD_DETAILS}
        component={GateCardDetail}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
    </Stack.Navigator>
  );
};

export const gateCardScreens = {
  [E_NAVIGATION_DESTINATIONS.GATE_CARDS_LIST] :"/gateCardsList",
  [E_NAVIGATION_DESTINATIONS.GATE_CARD_DETAILS] :"/gateCardDetails",
}

export default GatecardsNavigator;
